import { apiEmpleo } from "../../util/ApiEmpleo";

export type TSetting = {
  key: string;
  value: string;
};

export const apiGetSetting = async (key: string): Promise<TSetting> => {
  return await apiEmpleo.get(`settings/${key}`, { hideLoadingState: true });
};
